import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d6f9322"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-content" }
const _hoisted_2 = {
  key: 0,
  class: "footer-nav-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-nav-divider" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-nav-divider" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-nav-divider" }, null, -1))
const _hoisted_6 = { class: "footer-nav-item" }
const _hoisted_7 = {
  key: 0,
  class: "footer-nav-point"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-nav-divider" }, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "footer-nav"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-nav-divider" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideLink)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.tipState === 'normal')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["footer-nav", [_ctx.isEng ? 'footer-nav-padding-en' : 'footer-nav-padding']])
              }, [
                (_ctx.inApp)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", {
                        class: "footer-nav-text",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoPro('loan_know')))
                      }, _toDisplayString(_ctx.$t('贷款须知')), 1),
                      _hoisted_3
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "footer-nav-text",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.jumpCommon && _ctx.jumpCommon(...args)))
                }, _toDisplayString(_ctx.$t('常见问题')), 1),
                _hoisted_4,
                _createElementVNode("div", {
                  class: "footer-nav-text",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.bottomJump && _ctx.bottomJump(...args)))
                }, _toDisplayString(_ctx.$t('贷款记录')), 1),
                (!_ctx.inApp)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_5,
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", {
                          class: "footer-nav-text",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.jumpCoupon && _ctx.jumpCoupon(...args)))
                        }, _toDisplayString(_ctx.$t('优惠券')), 1),
                        (_ctx.showCouponRedPoint)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                          : _createCommentVNode("", true)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (!_ctx.inApp)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _hoisted_8,
                      _createElementVNode("div", {
                        class: "footer-nav-text",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.jumpProto && _ctx.jumpProto(...args)))
                      }, _toDisplayString(_ctx.$t('电子合同')), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.tipState === 'unNormal')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_ctx.inApp)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", {
                        class: "footer-nav-text",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.gotoPro('loan_know')))
                      }, _toDisplayString(_ctx.$t('贷款须知')), 1),
                      _hoisted_10
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "footer-nav-text",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.jumpCommon && _ctx.jumpCommon(...args)))
                }, _toDisplayString(_ctx.$t('常见问题')), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["flex-row-ct", { 'margin-bottom-20': _ctx.isFusionBankApp }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["base-font text-align-center", [_ctx.isEng ? 'tip__eng' : 'tip']])
      }, _toDisplayString(_ctx.$t('借定唔借？还得到先好借!')), 3)
    ], 2)
  ]))
}